import { sendVisitorAllocatedVariations, sendVisitorExposedVariations } from './handleSdkMessage';
export function onQaAssistantReady(visitorVariationState) {
    if (visitorVariationState.visitorVariations) {
        sendVisitorAllocatedVariations(visitorVariationState);
    }
    if (visitorVariationState.exposedVariations) {
        sendVisitorExposedVariations(visitorVariationState);
    }
}
